module.exports = __webpack_public_path__ + "static/media/8-hybrid.881ea5dd.png";